export const AdminCampaignRequestPermissions = {
  AdminCampaignRequestPermissions: {
    permissionsId: "1a0e14bb-e304-42e4-c4ce-08dc683b0c43",
    permissionsName: "Campaign Request",
    description: null,
    componentsId: null,
    components: null
  },
};
